module.exports = __webpack_public_path__ + "static/media/info-icon.5283b4db.svg";